<template>
	<div class="news-container">
		<div class="news-list">
			<div class="news-item" v-for="(item, index) in newsList" :key="index" @click="gotoDetail(item)">
				<div class="news-content">
					<h4>{{ item.title }}</h4>
					<p>{{ item.subtitle }}</p>
				</div>
				<div class="news-image">
					<img :src="item.title_image_url" :alt="item.title" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { newsApi, baseImgUrl } from '../netTool/api';
export default {
	name: 'NewsSection',
	data() {
		return {
			newsList: [],
			newsListCN: [],
			newsListEN: []
		};
	},
	mounted() {
		this.loadNewsList();
	},
	watch: {
		'$i18n.locale': {
			handler(newVal, oldVal) {
				if (newVal === 'en') {
					this.newsList = this.newsListEN;
				} else {
					this.newsList = this.newsListCN;
				}
			},
			deep: true
		}
	},
	methods: {
		async loadNewsList() {
			try {
				const response = await newsApi.getNewsList();
				if (response.success) {
					let list = response.newsList.map((news) => ({
						title_image_url: news.title_image_url ? baseImgUrl + news.title_image_url : '',
						title: news.title,
						subtitle: news.subtitle,
						id: news.id,
						type: news.type,
					}));
					this.newsListCN = list.filter(item => item.type === 'cn');
					this.newsListEN = list.filter(item => item.type === 'en');
					if (this.$i18n.locale === 'en') {
						this.newsList = this.newsListEN;
					} else {
						this.newsList = this.newsListCN;
					}
				}
			} catch (error) {}
		},
		gotoDetail(news) {
			this.$router.push(`/newsDetail/${news.id}`);
		}
	}
};
</script>

<style scoped>
.news-container {
	max-width: 1200px;
	margin: 0 auto;
	margin-top: 25px;
	margin-bottom: 45px;
}

.news-list {
	display: flex;
	flex-direction: column;
}

.news-item {
	display: grid;
	grid-template-columns: 3fr 1fr;
	overflow: hidden;

	padding-top: 13px;
	padding-bottom: 15px;
	border-top: 1px solid #ececec;
	transition: all 0.3s ease;
}

.news-item :hover {
	cursor: pointer;
	transform: translateY(-2px);
}

.news-content {
	display: grid;
	grid-template-columns: 1fr 2fr;
}

.news-content h4 {
	color: #333;
}

.news-content p {
	color: #666;
}

.news-image {
	width: 100%;
	aspect-ratio: 320/142;
}

.news-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 768px) {
	.news-container{
		margin-left: 20px;
		margin-right: 20px;
	}

	.news-item {
		grid-template-columns: 1fr;
		padding: 15px 0;
	}

	.news-content {
		grid-template-columns: 1fr;
		margin-bottom: 12px;
	}

	.news-image {
		width: 100%;
		aspect-ratio: auto;
		height: auto;
		margin-top: 12px;
	}

	.news-content h4 {
		font-size: 1.25rem;
	}

	.news-content p {
		font-size: 0.9rem;
	}
}
</style>
